import { Team } from '@internal/schemas-common';
import { useMemo } from 'react';

import { green, orange, red } from '@material-ui/core/colors';
import { ScoreIndex, SimpleScore, StackedBarChart } from '@internal/ui-common';

export const RenovateStackedBarChart = ({
  scores,
  teams,
}: {
  scores: ScoreIndex<SimpleScore>[];
  teams: Team[];
}) => {
  const chartData = useMemo(
    () =>
      scores.map(sc => ({
        teamName: teams[sc.index].name,
        team: teams[sc.index],
      })),
    [scores, teams],
  );

  const series = useMemo(
    () => [
      {
        data: scores.map(sc => sc.score.red),
        label: 'Need Attention',
        stack: 'total',
        barLabel: 'value' as const,
      },
      {
        data: scores.map(sc => sc.score.orange ?? 0),
        label: 'Advisory',
        stack: 'total',
        barLabel: 'value' as const,
      },
      {
        data: scores.map(sc => sc.score.green ?? 0),
        label: 'Healthy',
        stack: 'total',
        barLabel: 'value' as const,
      },
    ],
    [scores],
  );

  return (
    <StackedBarChart
      chartData={chartData}
      series={series}
      routeSuffix="renovate"
      colors={[red[300], orange[300], green[400]]}
    />
  );
};
